export const getNameTypeDocument = (name: string, objectNames: { [key: string]: string }): string => {
    const foundEntry = Object.entries(objectNames).find(item => item[1] === name);
    const value = foundEntry?.[1];
    return value ?? '';
};
